import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Aligner } from '@alfa-bank/site-aligner';
import { IconError } from '@alfa-bank/site-icon/error';
import { Text } from '@alfa-bank/site-text-v2';
import { Button } from '@alfa-bank/site-button-v2';

import { ErrorSendLayout as Component } from '../error-send-layout';
import type { TErrorSendLayoutDesktop, IDepsDesktop } from '../models';

import styles from './desktop.css';

export const ErrorSendLayoutDesktop = createWidget<IDepsDesktop, TErrorSendLayoutDesktop>({
    Aligner,
    Button,
    IconError,
    Text,
    styles,
    isMobile: false,
})(Component);
